import { useShallow } from "zustand/react/shallow";
import { useBoundStore } from "../bound.store";

export const useIsOwner = () => {
  const { roles } = useBoundStore(
    useShallow((s) => ({
      roles: s.wpUser?.roles,
    })),
  );

  return roles?.includes("owner");
};
